import React from "react";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "../recontext/store";
import { api } from "../services/index";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    borderRadius: 8,
    background: "rgba(93,66,93,0.7)",
    boxShadow: "0 10px 34px rgba(93,66,93,.4), 0 2px 16px rgba(93,66,93,.2);",
    "&:hover": {
      background: "rgba(93,66,93,1)"
    }
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  }
});

class ButtonOut extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = { loading: false };
  }

  async handleClick() {
    this.setState({
      loading: true
    });

    await api.leftTeam();
    this.setState({
      loading: false
    });
  }

  render() {
    const { classes, user, teamId } = this.props;
    const { loading } = this.state;

    if (!user || user.id === user.teamId || teamId !== user.teamId) return null;

    return (
      <Button
        variant="contained"
        color="secondary"
        className={classes.button}
        onClick={this.handleClick}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress className={classes.leftIcon} size={24} />
        ) : (
          <Icon className={classes.leftIcon}>swap_horiz</Icon>
        )}
        Quit
      </Button>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(withStyles(styles)(ButtonOut));
